import { useSearchParams } from '~/hooks/search/useSearchParams';

export const useCanShowBoardsInAllContent = () => {
  const { hasSearchParams } = useSearchParams();

  return {
    canShowBoards: hasSearchParams,
  };
};
